// /src/models/marketsService.js

const BASE_URL = 'https://api.polygon.io';

// Get the most up-to-date market data for all traded stock symbols.
export const fetchAllStocks = async () => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;

      console.log("API Key: " + apiKey);

      const response = await fetch(
        `${BASE_URL}/v2/snapshot/locale/us/markets/stocks/tickers?apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for : ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; // re-throw if you want to handle it in your component
    }
};

// Get the most up-to-date market data for the current top 20 gainers of the day in the stocks/equities markets.
export const fetchGainers = async () => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;

      const response = await fetch(
        `${BASE_URL}/v2/snapshot/locale/us/markets/stocks/gainers?apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for : ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; // re-throw if you want to handle it in your component
    }
};

// Get the most up-to-date market data for the current top 20 losers of the day in the stocks/equities markets.
export const fetchLosers = async () => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;

      const response = await fetch(
        `${BASE_URL}/v2/snapshot/locale/us/markets/stocks/losers?apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for : ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; // re-throw if you want to handle it in your component
    }
};

// Get the most up-to-date market data for a single traded stock ticker.
export const fetchStock = async (symbol) => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
      // Example: you might hit the "/v2/aggs/ticker" or "/v1/..." endpoints
      // Adjust the endpoint to match the data you need from Polygon
      const response = await fetch(
        `${BASE_URL}/v3/reference/tickers/${symbol}?apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for ${symbol}: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; 
    }
  };

  export const fetchStockInfo = async (symbol) => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
      // Example: you might hit the "/v2/aggs/ticker" or "/v1/..." endpoints
      // Adjust the endpoint to match the data you need from Polygon
      const response = await fetch(
        `${BASE_URL}/v2/snapshot/locale/us/markets/stocks/tickers/${symbol}?apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for ${symbol}: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; 
    }
  };

// Get the previous day's open, high, low, and close (OHLC) for the specified stock ticker.
export const fetchPrevClose = async (symbol) => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
    // Example: you might hit the "/v2/aggs/ticker" or "/v1/..." endpoints
    // Adjust the endpoint to match the data you need from Polygon
    const response = await fetch(
      `${BASE_URL}/v2/aggs/ticker/${symbol}/prev?adjusted=true&apiKey=${apiKey}`
    );

    if (!response.ok) {
      throw new Error(`Error fetching data for ${symbol}: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};

// Get Ticker News
export const fetchTickerNews = async (symbol, limit) => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;

    const response = await fetch(
      `${BASE_URL}/v2/reference/news?ticker=${symbol}&limit=${limit}&sort=published_utc&apiKey=${apiKey}`
    );

    if (!response.ok) {
      throw new Error(`Error fetching data for ${symbol}: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};


// Get all ticker symbols suppoted by Polygon.io. This API currently includes Stocks/Equities, Indices, Forex, and Crypto.
export const fetchAllTickerSymbols = async (market, limit) => {
    try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
  
      const response = await fetch(
        `${BASE_URL}/v3/reference/tickers?market=${market}&active=true&limit=${limit}&apiKey=${apiKey}`
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching data for ${market}: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw error; 
    }
  };

  export const fetchWatchlistStocks = async (tickers) => {
    try {
        const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
        // const tickerString = tickers.join(","); // Convert array to comma-separated string
        const response = await fetch(
            `${BASE_URL}/v2/snapshot/locale/us/markets/stocks/tickers?tickers=${tickers}&apiKey=${apiKey}`
        );

        if (!response.ok) {
            throw new Error(`Error fetching data: ${response.status}`);
        }

        const data = await response.json();
        return data.tickers || []; // Ensure it returns an array
    } catch (error) {
        console.error("Error fetching watchlist stocks:", error);
        return [];
    }
};


export const fetchAggregateBar = async (symbol, multiplier, timespan, timeStart, timeEnd) => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
    const response = await fetch(
      `${BASE_URL}/v2/aggs/ticker/${symbol}/range/${multiplier}/${timespan}/${timeStart}/${timeEnd}?adjusted=true&sort=asc&apiKey=${apiKey}`
    );

    if (!response.ok) {
      throw new Error(`Error fetching data for ${symbol}: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};
// https://api.polygon.io/v2/aggs/ticker/AAPL/range/30/minute/1741096800000/1741114800000?adjusted=true&sort=asc&apiKey=ai4Cb4cEosnZY4ylKvG3vtxWNVTTmHUt
// https://api.polygon.io/v2/aggs/ticker/AAPL/range/1/minute/1741096800000/1741114800000?adjusted=true&sort=asc&apiKey=KO2tVcjpEIe8tlJtZZPzZV44Xgj6TBVU

export const fetchStockHistory = async (symbol) => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
    let now = new Date();

    // Define 9 AM ET in UTC
    let marketOpenUTC = new Date();
      marketOpenUTC.setUTCHours(13, 30, 0, 0); // 9 AM ET = 14:00 UTC

    if (now < marketOpenUTC) {
      marketOpenUTC.setUTCDate(marketOpenUTC.getUTCDate() - 1);
      now.setUTCDate(now.getUTCDate() - 1);
    }

    let today = now.toISOString().split("T")[0];



    // Convert current time to UTC timestamp
    const nowUTC = now.getTime();
    const marketOpenTimestamp = marketOpenUTC.getTime();

    const response = await fetch(
      `https://api.polygon.io/v2/aggs/ticker/${symbol}/range/5/minute/${today}/${today}?adjusted=true&sort=asc&apiKey=${apiKey}`
    );

    if (!response.ok) {
      throw new Error(`Error fetching history for ${symbol}: ${response.status}`);
    }

    const data = await response.json();
    if (!data.results) return { normalizedHistory: [], normalizedFuture: [] };

    // Extract closing prices and timestamps
    const closingPrices = data.results.map(entry => entry.c);
    const timestamps = data.results.map(entry => entry.t); // Polygon returns timestamps

    // Find the first index that is at or after 9 AM ET
    const startIndex = timestamps.findIndex(time => time >= marketOpenTimestamp);

    // Trim data to start at 9 AM ET
    const trimmedPrices = closingPrices.slice(startIndex);
    // console.log("Start index: " + startIndex)
    const trimmedData = data.results.slice(startIndex);

    if (trimmedPrices.length === 0) {
      console.warn(`No intraday data available for ${symbol}`);
      return { normalizedHistory: [], normalizedFuture: [] };
    }

    // Normalize history for sparkline contrast
    const minPrice = Math.min(...trimmedPrices);
    const maxPrice = Math.max(...trimmedPrices);
    const normalizedHistory = trimmedPrices.map(price => (price - minPrice) / (maxPrice - minPrice));

    // Generate future placeholder (dotted line)
    const avgPrice = trimmedPrices.reduce((sum, price) => sum + price, 0) / trimmedPrices.length;
    const normalizedFuture = new Array(6).fill((avgPrice - minPrice) / (maxPrice - minPrice));

    // console.log(`Fetched history for ${symbol}:`, { normalizedHistory, normalizedFuture });

    return { normalizedHistory, normalizedFuture, trimmedPrices, data: trimmedData };
  } catch (error) {
    console.error(`Error fetching history for ${symbol}:`, error);
    return { normalizedHistory: [], normalizedFuture: [] , trimmedPrices: []};
  }
};

// Get Ticker Details
export const fetchTickerDetails = async (ticker) => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
    const url = `${BASE_URL}/v3/reference/tickers/${ticker}?apiKey=${apiKey}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching data for ${ticker}: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};

// Get Market Status
export const fetchMarketStatus = async () => {
  try {
    const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
    const url = `${BASE_URL}/v1/marketstatus/now?apiKey=${apiKey}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching market status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error; 
  }
};

export const fetchStocks = async (query) => {
  try {
      const apiKey = process.env.REACT_APP_POLYGON_API_KEY;
      const response = await fetch(`${BASE_URL}/v3/reference/tickers?search=${query}&active=true&limit=10&apiKey=${apiKey}`);
      
      if (!response.ok) throw new Error(`Error fetching stock data: ${response.status}`);

      const data = await response.json();
      return data.results.map(stock => ({
          ticker: stock.ticker,
          name: stock.name,
          price: stock.lastTrade?.p || 0,
          change: stock.todaysChangePerc || 0,
          history: [] // Placeholder for sparkline chart
      }));
  } catch (error) {
      console.error("Error fetching stocks:", error);
      return [];
  }
};

